import { render, staticRenderFns } from "./BuildingDisplayComponent.vue?vue&type=template&id=7dc178cc&"
import script from "./BuildingDisplayComponent.vue?vue&type=script&lang=ts&"
export * from "./BuildingDisplayComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports